import React from 'react';
import { getTheme, ITheme, mergeStyles } from '@fluentui/react';
import { MarkdownTimingIcon } from '../../../../../components/timing-icon';
import { TimingMode } from '../../../../../entities/timing-mode';
import { TimingState } from '../../../../../entities/timing-state';
import { ITimingSpecComponentModel } from '../../../parser/timing-spec';
import { BwjPalette } from '../../../../app-theme';

export interface IPRIVATE_MARKDOWN_TIMING_SECTION_HEADER_TIMING_INFOProps {
  componentModel: ITimingSpecComponentModel;
  firmTimingTitle: string;
  flexTimingTitle: string;
  shareTimingTitle: string;
  computedTimeShareDurationDescription: string;
  uncomputedTimeShareDurationDescription: string;
  firmTimeDurationDescription: string;
  flexTimeDurationDescription: string;
}

const getTimingIconStyling = (timingState: TimingState, theme: ITheme) => {

  let indicatorColor = theme.palette.neutralSecondary;
  switch(timingState) {
    case TimingState.Active:
      indicatorColor = BwjPalette.themeSuccess;
      break;
    case TimingState.Warning:
      indicatorColor = BwjPalette.themeWarning;
      break;
    case TimingState.Overtime:
      indicatorColor = BwjPalette.themeError;
      break;
  }

  const style: React.CSSProperties = {
    width: '3.144em',
    height: '2.0em',
    color: theme.palette.neutralTertiary,
    display: 'block',
  };

  return { style, indicatorColor };
}

const getDurationAndDescription = (props: IPRIVATE_MARKDOWN_TIMING_SECTION_HEADER_TIMING_INFOProps) => {
  const model = props.componentModel;
  let description = '';
  let duration = '';

  if(model.specType === TimingMode.ShareTime) {
    description = model.computedPrimaryUnits !== undefined ? props.computedTimeShareDurationDescription : props.uncomputedTimeShareDurationDescription;
    duration = model.computedPrimaryUnits !== undefined ?
      `${model.primaryUnits} (${model.computedPrimaryUnits ?? 0}:${model.computedSubUnits?.toString().padStart(2, '0') ?? '00'})`
      : model.primaryUnits.toString();
  } else {
    description = model.specType === TimingMode.FirmTime ? props.firmTimeDurationDescription : props.flexTimeDurationDescription;
    duration = model.computedPrimaryUnits !== undefined ?
    `${model.computedPrimaryUnits ?? 0}:${model.computedSubUnits?.toString().padStart(2, '0') ?? '00'}`
    : `${model.primaryUnits}:${model.subUnits?.toString().padStart(2, '0') ?? '00'}`;
  }

  return { duration, description };
}

export const PRIVATE_MARKDOWN_TIMING_SECTION_HEADER_TIMING_INFO: React.FunctionComponent<IPRIVATE_MARKDOWN_TIMING_SECTION_HEADER_TIMING_INFOProps> = (props) => {
  const theme = getTheme();
  const { componentModel } = props;
  const iconStyling = getTimingIconStyling(componentModel.timingState, theme);
  const durationInfo = getDurationAndDescription(props);

  const className = mergeStyles([{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: '0.7143em',
  }]);
    
  const durationClass = mergeStyles([{
    marginTop: '0.35em',
    fontSize: '0.8em',
    fontWeight: 600,
    color: theme.palette.neutralSecondary,
  }]);

  return (
    <div className={className}>
      <MarkdownTimingIcon
        timingMode={componentModel.specType}
        style={iconStyling.style}
        indicatorColor={iconStyling.indicatorColor}
        firmTimingTitle={props.firmTimingTitle}
        flexTimingTitle={props.flexTimingTitle}
        shareTimingTitle={props.shareTimingTitle}
      />
      <span className={durationClass} title={durationInfo.description}>{durationInfo.duration}</span>
    </div>
  );
};
